import { getTrainingReviewQueue, getTrainingFollowUpQueue } from './trainingReviewNavigation';

export const getVisibleCanonicalQualifications = (records = []) => (
  records.filter((record) => {
    const evidenceType = String(record?.evidence_type || '').trim().toLowerCase();
    return evidenceType !== 'temporary_internal';
  })
);

export const getPendingProposedTrainingItems = (proposedItems = []) => (
  getTrainingReviewQueue(proposedItems)
);

export const getTrainingLibraryBannerState = ({
  proposedItems = [],
  proposedItemsErrored = false,
}) => {
  if (proposedItemsErrored) {
    return {
      tone: 'error',
      title: 'Cannot assess extracted training reviews',
      body: 'Extracted training review data did not load, so awaiting-review guidance is unavailable right now.',
    };
  }

  const pendingCount = getPendingProposedTrainingItems(proposedItems).length;
  const followUpCount = getTrainingFollowUpQueue(proposedItems).length;
  if (pendingCount > 0) {
    return {
      tone: 'instructional',
      title: 'How training evidence becomes compliant',
      body: 'Certificates are evidence only. Extracted items appear below for review, then become canonical qualifications only after admin approval. Mandatory compliance still requires verified and current training records.',
    };
  }

  if (followUpCount > 0) {
    return {
      tone: 'attention',
      title: `${followUpCount} extracted training item(s) need follow-up`,
      body: 'These items are not verified. They need clarification or a reviewer status check; do not re-upload evidence merely to clear this queue.',
    };
  }

  return {
    tone: 'clear',
    title: 'No extracted training items awaiting review',
    body: 'Approved qualifications below are already part of the canonical training record set. New certificate extractions will appear here only when admin review is still needed.',
  };
};

/**
 * Keep the qualifications screen focused on current or deployment-relevant
 * evidence. Expired optional and explicitly superseded records remain in an
 * accessible history view; never mutate the source records or hide a mandatory
 * blocker from the manager.
 */
export const partitionCanonicalQualifications = (records = [], {
  isRequired = () => false,
  getStatus = (row) => row?.status,
} = {}) => {
  const current = [];
  const historical = [];
  for (const record of records) {
    const recordStatus = String(record?.record_status || '').toLowerCase();
    const status = String(getStatus(record) || '').toLowerCase();
    const oldEvidence = ['superseded', 'deleted'].includes(recordStatus);
    const expiredOptional = ['expired', 'overdue'].includes(status) && !isRequired(record);
    (oldEvidence || expiredOptional ? historical : current).push(record);
  }
  return { current, historical };
};
